export type ModelCapability = 'text' | 'vision' | 'structured_output';

export type PresetModel = {
  modelKey: string;
  displayName: string;
  maxInputTokens: number;
  maxOutputTokens: number;
  capabilities: ModelCapability[];
  pricingRates: {
    inputPerMillionTokens: number;
    outputPerMillionTokens: number;
    cacheReadPerMillionTokens: number | null;
  };
  supportsStrictSchema?: boolean;
};

export type ProviderOption = {
  key: string;
  name: string;
  baseUrl: string;
  badge: string;
  description: string;
  apiKeyPlaceholder: string;
  models: PresetModel[];
};

export const PROVIDER_OPTIONS: ProviderOption[] = [
  {
    key: 'openrouter',
    name: 'OpenRouter',
    badge: 'Multi-Model',
    baseUrl: 'https://openrouter.ai/api/v1',
    description: 'Unified gateway to 400+ models including DeepSeek, Claude, GPT, and Llama.',
    apiKeyPlaceholder: 'sk-or-v1-...',
    models: [],
  },
  {
    key: 'gemini',
    name: 'Google Gemini',
    badge: 'Google AI',
    baseUrl: 'https://generativelanguage.googleapis.com/v1beta/openai',
    description: 'Direct Google Gemini models via Google AI Studio API.',
    apiKeyPlaceholder: 'AIzaSy...',
    models: [],
  },
  {
    key: 'deepseek',
    name: 'DeepSeek',
    badge: 'Reasoning',
    baseUrl: 'https://api.deepseek.com',
    description: 'Direct DeepSeek API (V3 and R1 Reasoner).',
    apiKeyPlaceholder: 'sk-...',
    models: [],
  },
  {
    key: 'openai',
    name: 'OpenAI',
    badge: 'Frontier',
    baseUrl: 'https://api.openai.com/v1',
    description: 'Direct OpenAI models (GPT-4o, o1, o3-mini).',
    apiKeyPlaceholder: 'sk-proj-...',
    models: [],
  },
  {
    key: 'custom',
    name: 'Custom (OpenAI-compatible)',
    badge: 'Custom URL',
    baseUrl: 'https://api.example.com/v1',
    description: 'Configure any custom OpenAI-compatible allowlisted HTTPS endpoint.',
    apiKeyPlaceholder: 'Bearer token or API key',
    models: [],
  },
];
